import { useState, memo } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import LoadingSpinner from '../components/LoadingSpinner';

const SignUpPenulis = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    if (e.target.name === 'email') {
      // Only get the username part before @
      const emailValue = e.target.value.split('@')[0];
      setFormData(prev => ({
        ...prev,
        email: `${emailValue}@sie1ketaqwaan.my.id`
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [e.target.name]: e.target.value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await authAPI.registerWriter(formData);
      if (response.data) {
        setSuccess(true);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Pendaftaran gagal');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full lg:space-y-6 space-y-4">
        <div>
          <h2 className="lg:mt-6 mt-2 text-center text-2xl font-extrabold text-gray-900">
            Daftar sebagai Penulis
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Atau{' '}
            <Link to="/login" className="font-medium text-primary-600 hover:text-primary-500">
              masuk ke akun Anda
            </Link>
          </p>
        </div>
        
        {error && <p className="text-red-500 text-center lg:text-sm text-xs">{error}</p>}
        {success && (
          <div className="bg-teal-50 border border-teal-200 rounded-md p-4 text-center">
            <p className="text-teal-600 mb-2 text-base">
              Pendaftaran berhasil!
            </p>
            <p className="text-gray-700 mb-2 text-xs">
              Selamat bergabung menjadi bagian penulis SIE 1 Ketaqwaan MAN 1 Jember.
            </p>
            <p className="text-gray-700 mb-2 text-xs">
              Gunakan email: <span className="font-semibold">{formData.email}</span>
            </p>
            <p className="text-gray-700 text-xs">
              dan password yang sudah kamu buat untuk login.
            </p>
          </div>
        )}

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label htmlFor="name" className="block lg:text-sm text-xs font-medium text-gray-700">
                Nama Lengkap
              </label>
              <input
                id="name"
                name="name"
                type="text"
                required
                value={formData.name}
                onChange={handleChange}
                className="mt-1 block w-full px-3 py-2 lg:text-sm text-xs border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500"
                placeholder="Masukkan nama lengkap"
              />
            </div>
            <div>
              <label htmlFor="email" className="block lg:text-sm text-xs font-medium text-gray-700">
                Email
              </label>
              <div className="mt-1 flex rounded-md shadow-sm">
                <input
                  id="email"
                  name="email"
                  type="text"
                  required
                  value={formData.email.split('@')[0]}
                  onChange={handleChange}
                  className="flex-1 min-w-0 block w-full px-3 py-2 lg:text-sm text-xs rounded-none rounded-l-md border border-gray-300 focus:outline-none focus:ring-primary-500 focus:border-primary-500"
                  placeholder="username"
                />
                <span className="inline-flex items-center px-3 py-2 rounded-r-md border border-l-0 border-gray-300 bg-gray-50 text-gray-500 lg:text-sm text-xs">
                  @sie1ketaqwaan.my.id
                </span>
              </div>
            </div>
            <div>
              <label htmlFor="password" className="block lg:text-sm text-xs font-medium text-gray-700">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                value={formData.password}
                onChange={handleChange}
                className="mt-1 block w-full px-3 py-2 lg:text-sm text-xs border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500"
                placeholder="Minimal 6 karakter"
                minLength={6}
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={loading}
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50"
            >
              {loading ? <LoadingSpinner size="sm" /> : 'Daftar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default memo(SignUpPenulis);